import React from 'react';
import { useTranslation } from 'react-i18next';

export interface ActivityData {
  isOldData: boolean;
  oldResult: any[];
  newResult: {
    sitUpCount: any[];
    lieDownCount: any[];
    leaveBedCount: any[];
    turnOverCount: any[];
  };
}

interface FourIndicatorsChartProps {
  data: ActivityData['newResult'];
  chartSwitch: number;
}

const HisFourIndicatorsChart: React.FC<FourIndicatorsChartProps> = ({ data, chartSwitch }) => {
  const {t} = useTranslation()
  const chartData = getData(chartSwitch, data);
  const currentMeta = chartMeta[chartSwitch] ?? chartMeta[0];
  const timeData = chartData[1] || null;
  const formattedList = chartData[2] || [];
  const backgroundColor = bgColor[chartSwitch];
  return (
    <div className="fx-d-c h-100 w-100 ">
      <div className="font-ml fx-d-r">
        <div className="mov-col-m fx-ccc row_title">{t("GLOBAL.DATE")}</div>
        <div className="mov-col-m fx-ccc row_title">{t("HISTORY_RECORD.MOBILITY_START")}</div>
        <div className="mov-col-m fx-ccc row_title">{t("HISTORY_RECORD.MOBILITY_END")}</div>
        <div className="mov-col-m fx-ccc row_title">{t("HISTORY_RECORD.MOBILITY_DURATION")}</div>
      </div>
      <div className="fx-d-c gap10 h-90 pad-10 t of-auto font-ml">
        {formattedList.map((entry: any, index: number) => (
          <div
            key={index}
            className="fx-d-r"
            style={{
              backgroundColor: index % 2 !== 0 ? backgroundColor : 'transparent',
            }}>
            {entry.map((item: any, subIndex: number) => (
              <div key={subIndex} className="mov-col-m fx-ccc">
                {item}
              </div>
            ))}
          </div>
        ))}
      </div>
      {timeData && (
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '0 30px', margin: '5px 0', width: '100%' }}>
          
          {/* 左邊：標題 + 時間範圍 */}
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
            <div className="font-md">
              {t(currentMeta.titleKey)}
            </div>
            <div className="font-sm">
              {t(currentMeta.rangeKey)}
            </div>
          </div>

          {/* 右邊：總時間 */}
          <div className="font-xl">
            {t("HISTORY_RECORD.MOBILITY_TOTAL_TIME")}：{timeData}
          </div>

        </div>
      )}
    </div>
  );
};

export default HisFourIndicatorsChart;

//判斷分頁對應資料
function getData(chartSwitch: number, data: any) {
  switch (chartSwitch) {
    case 0:
      return data.sitUpCount;
    case 1:
      return data.lieDownCount;
    case 2:
      return data.leaveBedCount;
    case 3:
      return data.turnOverCount;
    default:
      return [];
  }
}

type ChartMetaItem = {
    titleKey: string;
    rangeKey: string;
  };

  const chartMeta: ChartMetaItem[] = [
    {
      titleKey: "HISTORY_RECORD.SIT_UP_COUNT_AND_DURATION",
      rangeKey: "HISTORY_RECORD.SIT_UP_TIME_RANGE",
    },
    {
      titleKey: "HISTORY_RECORD.LIE_DOWN_COUNT_AND_DURATION",
      rangeKey: "HISTORY_RECORD.LIE_DOWN_TIME_RANGE",
    },
    {
      titleKey: "HISTORY_RECORD.OUT_OF_BED_COUNT_AND_DURATION",
      rangeKey: "HISTORY_RECORD.OUT_OF_BED_TIME_RANGE",
    },
    {
      titleKey: "HISTORY_RECORD.TURN_OVER_COUNT_AND_DURATION",
      rangeKey: "HISTORY_RECORD.TURN_OVER_TIME_RANGE",
    },
  ];

//資料背景顏色根據活動力柱狀圖
const bgColor = ['rgba(251, 188, 4, 0.5)', 'rgba(52, 168, 83, 0.5)', 'rgba(66, 133, 244, 0.5)', 'rgba(255, 171, 145, 0.5)'];
